import * as types from '../mutation-types'
import ajax from 'api/message'

const state = {
  count: 0,
  detail: null
}

const getters = {
  getUnReadCount: state => state.count,
  getMessageDetail: state => state.detail,
}


const actions = {
  setUnReadCount ({ commit }) {
    ajax.unreadCount({}).then(data => {
      if (data && data.flag) {
        commit(types.SET_UNREAD_MSG, data.data)
      } else {
        if (data) {
        }
      }
    })
  },
  setMessageDetail ({ commit }, detail) {
    commit(types.SET_MSG_DETAIL, detail)
  }
}


const mutations = {
  [types.SET_UNREAD_MSG] (state, count) {
    state.count = count
  },
  [types.SET_MSG_DETAIL] (state, detail) {
    state.detail = detail
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./app/store/modules/message.js